import { FC } from "react";
import { LinkPage } from "../../common/components/LinkPage";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { Button } from "../../forms/components/Button";
import { t } from "../../common/miscellaneous/t";

export const SampleRouteButtons: FC = () => {
  return (
    <div className="tw-flex tw-gap-3">
      <LinkPage data-testid={DataTestids.SampleHomeLink} to="/samples">
        <Button
          className="tw-px-6"
          data-testid={DataTestids.SampleHomeButton}
        >
          {t("mk-hc-sample-page-button")}
        </Button>
      </LinkPage>
    </div>
  );
};
